export default {
  props: {
    summary: {
      type: Object,
      required: true
    }
  }
}
